export const PRODUCT_LINK = 'Shop this item';
export const FREE_UK_DELIVERY = 'Free UK Delivery';
